import React, {useEffect} from 'react';
import cn from 'classnames';

import {isTranslate} from 'shared/lib/lang';

import BaseLayout, {BaseLayoutProps} from 'shared/ui/BaseLayout/BaseLayout';

import ButtonSetting from '../ButtonSetting/ButtonSetting';

import NavigationToggle from './NavigationToggle/NavigationToggle';

import styles from './MainLayout.module.scss';

const MainLayout: React.FC<BaseLayoutProps> = (props) => {

    // Костыли из Inspinia
    const updateBodyClasses = (): void => {
        const body: HTMLBodyElement = document.getElementsByTagName('body')[0];

        if (window.innerWidth < 769) {
            body.classList.add('body-small');
        } else {
            body.classList.remove('body-small');
        }
    };

    useEffect(() => {
        updateBodyClasses();
        window.addEventListener('resize', updateBodyClasses);
    });

    // @ts-ignore
    return (
        <BaseLayout {...props}>
            <div className={cn(
                styles.layout,
                isTranslate() ? styles.enBackground : styles.ruBackground,
            )}>
                <NavigationToggle />
                <div className={styles['layout-wrapper']}>
                    {
                        props.pageTitle && (
                            <div className={cn('row', styles.pageHeading)}>
                                <div className="col-12">
                                    <div
                                        className={'d-sm-flex align-items-center justify-content-between'}
                                    >
                                        <h2 className={'page_heading'}>{props.pageTitle}</h2>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    <main className={cn(
                        styles['layout__main'],
                        props.isPlugMode &&  styles.isPlugMode,
                        props.className,
                    )}>
                        <div className={styles['layout-container']}>
                            {props.children}
                        </div>
                    </main>
                </div>
                <div className={styles.buttonsSetting}>
                    <ButtonSetting />
                </div>
            </div>
        </BaseLayout>
    );
};

export default MainLayout;